export class ModuleResult {
    public id: number = 0;
    public name: string = '';
    public isDeleted: boolean = false;
}
